import { render, staticRenderFns } from "./NavigatorBottomBarLinkHome.vue?vue&type=template&id=033e6469"
import script from "./NavigatorBottomBarLinkHome.vue?vue&type=script&lang=js"
export * from "./NavigatorBottomBarLinkHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports